export default __webpack_public_path__ + "static/media/dolby_new.91a809ee.jpeg";